import { useAuth, useCart, useCheckout } from "@the-volte/svc-core-sdk";
import { useRouter } from "next/router";
import * as React from "react";

import { CartSidebar } from "@components/organisms";
import { paths } from "@paths";

import { OverlayContextInterface } from "../..";

const Cart: React.FC<{ overlay: OverlayContextInterface }> = ({ overlay }) => {
  const { push } = useRouter();
  const { user } = useAuth();
  const { checkout } = useCheckout();

  const {
    items,
    updateItem,
    removeItem,
    subtotalPrice,
    shippingPrice,
    discount,
    totalPrice,
    borrowerFee,
  } = useCart();

  const shippingTaxedPrice =
    checkout?.shippingMethod?.id && shippingPrice
      ? {
          gross: shippingPrice,
          net: shippingPrice,
        }
      : null;
  const promoTaxedPrice = discount && {
    gross: discount,
    net: discount,
  };

  const borrowerFeeValue = borrowerFee?.amount;

  return (
    <CartSidebar
      show
      updateItem={updateItem}
      removeItem={removeItem}
      hide={overlay.hide}
      items={items}
      subtotalPrice={subtotalPrice}
      shippingTaxedPrice={shippingTaxedPrice}
      promoTaxedPrice={promoTaxedPrice}
      totalPrice={totalPrice}
      continueShopping={() => {
        overlay.hide();
      }}
      goToCart={() => {
        push(paths.checkout);
        overlay.hide();
      }}
      proceedToCheckout={() => {
        push(user ? paths.checkout : paths.login);
        overlay.hide();
      }}
      borrowerFee={borrowerFeeValue}
    />
  );
};

export default Cart;
